export default "__VITE_ASSET__Dgngfi05__"